module.exports = __webpack_public_path__ + "img/icon_du.63469d42.png";